import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Globe, MapPinned, Palette, ArrowUpRight } from "lucide-react";

const SERVICES = [
    {
        icon: Globe,
        title: "Création de site web",
        desc: "Site vitrine rapide et optimisé conversion. Formulaires de devis qui marchent vraiment, et pas un numéro caché en bas de page.",
        href: "/creation-site-web",
        cta: "Voir le détail",
    },
    {
        icon: MapPinned,
        title: "Référencement local (SEO)",
        desc: "On vous fait apparaître quand un client tape votre métier + votre ville. Fiche Google, avis clients, mots-clés qui rapportent.",
        href: "/referencement-local-seo",
        cta: "Voir le détail",
    },
    {
        icon: Palette,
        title: "Identité visuelle",
        desc: "Logo, charte, photos pro : on arrête le site qui ressemble à un document Word de 2008. Vous devenez crédible dès la première seconde.",
        href: "/identite-visuelle",
        cta: "Voir le détail",
    },
];

export default function Services() {
    return (
        <section
            id="services"
            className="relative bg-[#F7F7F5] text-[#1A1A2E] py-24 md:py-32"
            data-testid="services-section"
        >
            <div className="max-w-7xl mx-auto px-4 md:px-8">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
                    <div>
                        <span className="inline-flex items-center gap-2 rounded-full bg-[#2B7BE4]/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#2B7BE4]">
                            Expertises
                        </span>
                        <h2
                            className="mt-6 font-display font-bold tracking-tight text-balance max-w-2xl"
                            style={{ fontSize: "clamp(32px, 5vw, 48px)", lineHeight: 1.05 }}
                            data-testid="services-title"
                        >
                            Ce qu'on fait, concrètement.
                        </h2>
                    </div>
                    <p className="max-w-md text-[15px] md:text-base text-[#1A1A2E]/60 leading-relaxed">
                        Pas de blabla. Trois services qui se complètent, pensés pour générer des demandes de devis réelles.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {SERVICES.map((s, i) => (
                        <motion.div
                            key={s.title}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.12 }}
                        >
                            <Link
                                to={s.href}
                                className="group relative flex flex-col h-full rounded-2xl bg-white border border-[#1A1A2E]/5 p-8 shadow-[0_8px_30px_rgba(26,26,46,0.04)] hover:shadow-[0_28px_80px_rgba(43,123,228,0.12)] hover:border-[#2B7BE4]/40 transition-all duration-500 hover:-translate-y-1"
                                data-testid={`service-card-${i}`}
                            >
                                <div className="flex items-start justify-between">
                                    <div className="inline-flex size-12 items-center justify-center rounded-xl bg-[#2B7BE4] text-white group-hover:bg-[#2B7BE4] group-hover:text-white transition-colors duration-500">
                                        <s.icon size={22} strokeWidth={2} />
                                    </div>
                                    <span className="text-xs font-mono text-[#1A1A2E]/30">
                                        0{i + 1}
                                    </span>
                                </div>
                                <h3 className="mt-8 font-display text-2xl font-bold tracking-tight">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-[15px] text-[#1A1A2E]/70 leading-relaxed flex-1">
                                    {s.desc}
                                </p>
                                <div className="mt-8 pt-6 border-t border-[#1A1A2E]/5">
                                    <span
                                        className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#1A1A2E] group-hover:text-[#2B7BE4] transition-colors"
                                        data-testid={`service-cta-${i}`}
                                    >
                                        {s.cta}
                                        <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                                    </span>
                                </div>
                            </Link>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
